export default __webpack_public_path__ + "static/media/amp_permission.0ab39486.xlsx";